
import React from 'react';

const A0 = () => {

    return <>
        <h2>
            Tillgänglighet för LäraNäras portal
        </h2>

        <p>LäraNära AB står bakom den här webbplatsen. Vi vill att så
            många som möjligt ska kunna använda den. Det här dokumentet beskriver hur
            LäraNäras portal uppfyller lagen om vissa produkters och tjänsters
            tillgänglighet, eventuella kända tillgänglighetsproblem och hur du kan
            rapportera brister till oss så att vi kan åtgärda dem.</p>

        <h3>Hur tillgänglig är webbplatsen?</h3>

        <p>Vi är medvetna om att delar av webbplatsen inte är helt
            tillgängliga. Se avsnittet om innehåll som inte är tillgängligt nedan för mer
            information.</p>

        <h3>Vad kan du göra om du inte kan använda delar av webbplatsen?</h3>

        <p>Om du behöver innehåll från LäraNäras portal som inte är
            tillgängligt för dig, men som är undantaget från lagens tillämpningsområde
            enligt beskrivning nedan, kan du meddela oss via:</p>

        <ul>
            <li>
                Formuläret ”Feedback” inne på webbplatsen
            </li>

            <li>
                Via epost till info@laranara.se
            </li>

            <li>
                Telefon 0708 48 95 94 vardagar mellan 8-16.
            </li>

        </ul>

        <p>Svarstiden är normalt 1 arbetsdag.</p>

        <h3>Rapportera brister i webbplatsens tillgänglighet</h3>

        <p>Vi strävar hela tiden efter att förbättra webbplatsens
            tillgänglighet. Om du upptäcker problem som inte är beskrivna på den här sidan,
            eller om du anser att vi inte uppfyller lagens krav, meddela oss så att vi får
            veta att problemet finns.</p>

        <h3>Tillsyn</h3>

        <p>Myndigheten för digital förvaltning, Digg, har ansvaret för
            tillsyn över&nbsp;lagen om vissa produkters och tjänsters tillgänglighet.
             Du kan <a href="https://www.digg.se/tdosanmalan">anmäla till Digg</a> om om du tycker att vår digitala service har brister i
            tillgänglighet.</p>

        <p>Du kan också <a
            href="https://www.digg.se/tdosanmalan">anmäla till Digg</a> om du tycker
            att vår bedömning av vad som är oskäligt betungande ska granskas, om du tycker
            att vår tillgänglighetsredogörelse har brister eller om du tycker att vi inte
            har hanterat din begäran om tillgängliggörande korrekt.</p>

        <h3>Teknisk information om webbplatsens tillgänglighet</h3>

        <p>Den här webbplatsen är delvis förenlig med lagen om
            tillgänglighet, på grund av de brister som beskrivs nedan.</p>




        <h2>Innehåll som inte är tillgängligt</h2>

        <h3>För dig med nedsatt syn och färgseende eller utan synförmåga</h3>

        <ul>
            <li>Många ikoner saknar beskrivande alt-texter eller
                aria-label.</li>
            <li>Flera bilder och ikoner saknar alt-texter.</li>
            <li>Skärmläsare får inte tillgång till statusmeddelanden.</li>
            <li>Rubrikstrukturer saknas eller är felaktiga.</li>
            <li>Formulärfält saknar etiketter eller är felkopplade.</li>
            <li>Tabeller saknar rubriker och semantisk märkning.</li>
            <li>Kontraster är ofta otillräckliga.</li>
            <li>Fokusmarkering är otydlig eller saknas.</li>
            <li>Tangentbordsnavigering fungerar inte fullt ut.</li>
            <li>Vissa videor saknar undertexter, ljudbeskrivningar eller alternativ text.</li>
            <li>&quot;Hoppa till innehåll&quot; saknas.</li>
            <li>Dokumenttitlar är inte unika.</li>

            <li>Fokusordning brister.</li>
        </ul>
        <h3>För dig med nedsatt kognitiv förmåga</h3>

        <ul>
            <li>Innehåll saknar tydliga rubriker och logisk struktur.</li>
            <li>Ikoner och länkar är inte alltid självförklarande.</li>
            <li>Länkar som öppnas i ny flik informerar inte om detta.</li>
            <li>Ingen synlig eller tillgänglig hjälpfunktion finns.</li>

        </ul>

        <h3>För dig med nedsatt finmotorik eller styrka</h3>

        <ul>
            <li>Interaktiva mål är oftast tillräckligt stora.</li>
            <li>Vissa funktioner kräver musrörelser utan alternativ.</li>

        </ul>

        <h3>För dig med nedsatt hörsel eller utan hörsel</h3>

        <ul>
            <li>Förinspelade videor saknar ibland undertexter.</li>
            <li>Det finns ingen ljudbeskrivning till videor med viktig visuell information.</li>
        </ul>



        <h2>Åtgärder som planeras</h2>

        <p>Vi arbetar löpande med att förbättra tillgängligheten på
            LäraNära Portal. Följande åtgärder är identifierade som prioriterade och
            planeras att genomföras:</p>

        <h3>För användare med nedsatt syn eller färgseende</h3>

        <ul><li>Komplettera ikoner och bilder med beskrivande alt-texter
            och aria-labels.</li>
            <li>Säkerställa korrekt rubrikstruktur på alla sidor.</li>
            <li>Korrigera formulärfält med etiketter.</li>
            <li>Märka upp tabeller semantiskt.</li>
            <li>Förbättra kontrastnivåer.</li>
            <li>Förtydliga fokusmarkeringar.</li>
            <li>Göra alla interaktiva element tangentbordstillgängliga.</li>
            <li>Göra statusmeddelanden tillgängliga.</li>

        </ul>

        <h3>För användare med nedsatt kognitiv förmåga</h3>

        <ul><li>Förbättra rubriker och etiketter.</li>
            <li>Justera dokumenttitlar för tydlighet.</li>
            <li>Informera om länkar som öppnas i ny flik.</li>
            <li>Lägga till hjälp- och kontaktlänkar.</li>
        </ul>

        <h3>För användare med nedsatt finmotorik eller styrka</h3>

        <ul><li>Erbjuda alternativa metoder till musgester.</li>
        </ul>

        <h3>För användare med nedsatt hörsel eller utan hörsel</h3>

        <ul>
            <li>Transkribera och texta alla videor.</li>
            <li>Tillhandahålla ljudbeskrivningar eller textversioner av visuellt innehåll.</li>
        </ul>


        <p>Vår ambition är att ha åtgärdat alla kända
            tillgänglighetsproblem senast december 2025.</p>



        <h2>Hur vi testat webbplatsen</h2>

        <p>Toxic Interactive Solutions AB har gjort en oberoende
            granskning av LäraNäras portal</p>

        <p>Deras rapport finner du här: <a rel="noopener noreferrer" target='_blank'
            href="https://static.laranara.se/policies/Tillganglighetsanalys-LaraNara.pdf">Rapport</a></p>

        <p>Senaste bedömningen gjordes 2025-05-13 och utvärderades
            efter WCAG 2.2 upp till nivå AA.
        </p>


    </>

}

export default A0;